import React, { useState, useEffect } from 'react';
import IssuesTable from './issuesTable';
import constant from '../../constant';
import { useParams } from 'react-router-dom';

const IssuesContent = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { hospitalId } = useParams();

  useEffect(() => {
    const fetchIssues = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/issue/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (response.ok) {
          setIssues(result.map(issue => ({
            issue_id: issue.issue_id,
            user_name: issue.user_name,
            hospital_name: issue.hospital_name,
            issue_desc: issue.issue_desc,
            issue_summary: issue.issue_summary,
            remarks: issue.remarks,
            status: issue.status,
            hospital_id: issue.hospital_id,
            reported_on: issue.reported_on,
            resolved_on: issue.resolved_on,
            created_by: issue.created_by,
            is_active: issue.is_active,
          })));
        } else {
          setError(result.message || 'Failed to fetch issues');
        }
      } catch (error) {
        setError('Error fetching issues');
      } finally {
        setLoading(false);
      }
    };

    fetchIssues();
  }, []);

  const handleEdit = (updatedIssue) => {
    setIssues(issues.map((issue) =>
      issue.issue_id === updatedIssue.issue_id ? updatedIssue : issue
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500">
        {error}
        <button
          onClick={() => setError(null)}
          className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Clear Error
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <IssuesTable
          issues={issues}
          onEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default IssuesContent;